import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorTooltipModule } from '../../atoms/error-tooltip/error-tooltip.module';
import { InfoIconModule } from '../../atoms/info-icon/info-icon.module';
import { InformationSectionsModule } from '../../molecules/information-sections/information-sections.module';
import { CheckboxStandardComponent } from './checkbox-standard.component';

@NgModule({
  declarations: [CheckboxStandardComponent],
  imports: [
    CommonModule,
    ErrorTooltipModule,
    InformationSectionsModule,
    InfoIconModule
  ],
  exports: [CheckboxStandardComponent]
})
export class CheckboxStandardModule {}
